import cx from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import LayerIcon from './LayerIcon'

export type LayerControlProps = {
  styles?: React.CSSProperties
  onClick?: () => void
  active?: boolean
}

function LayerControlFC({ styles = {}, onClick, active }: LayerControlProps) {
  const { t } = useTranslation()

  return (
    <div style={styles}>
      <StyledControl>
        <button
          title={t('dashboard:search device')}
          onClick={onClick}
          className={cx({ active: active })}>
          <LayerIcon color="#fff" />
        </button>
      </StyledControl>
    </div>
  )
}

const StyledControl = styled.div`
  display: flex;
  flex-direction: row;
  user-select: none;
  box-shadow: rgb(0 0 0 / 30%) 0px 1px 4px -1px;
  border-radius: 4px;

  background-color: #fff;
  width: 32px;
  min-height: 32px;
  margin-top: unset !important;
  margin-right: unset !important;
  border: 0 !important;
  background-clip: unset !important;

  button {
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    min-height: 32px;
    color: #fff;
    background-color: #0486ff;
    border-radius: 4px;
    box-shadow: 0 2px 6px 0 rgb(0 0 0 / 30%);
    cursor: pointer;

    &.active,
    &:hover {
      background-color: #ffcc2b !important;
      color: #284d5d;

      svg path {
        fill: #284d5d;
      }
    }
  }
`

export default React.memo(LayerControlFC)
